import { ComponentProps } from "react";
import { cn } from "cn";

// The editor's behavior (focus, empty lines, lists, table selection and resizing). Type sizes come
// from the design system's document styles on the wrapper.
const EDITOR_BEHAVIOR = `
  .ProseMirror { outline: none !important; min-height: 100%; }
  .ProseMirror > :first-child { margin-top: 0; }
  .ProseMirror:focus, .ProseMirror-focused { outline: none !important; box-shadow: none !important; }
  .ProseMirror p { white-space: pre-wrap; }
  .ProseMirror ul, .ProseMirror ol { padding-left: 2.5rem; margin: 0.5rem 0; }
  .ProseMirror ul { list-style-type: disc; }
  .ProseMirror ul ul { list-style-type: circle; }
  .ProseMirror ul ul ul { list-style-type: square; }
  .ProseMirror ol { list-style-type: decimal; }
  .ProseMirror li { margin: 0.25rem 0; }
  .ProseMirror li p { margin: 0; }
  .ProseMirror li > ul, .ProseMirror li > ol { margin: 0.25rem 0; }
  .ProseMirror table { border-collapse: collapse; }
  .ProseMirror th, .ProseMirror td { border: 1px solid var(--border); padding: 0.5rem; vertical-align: top; text-align: left; }
  .ProseMirror .selectedCell { position: relative; }
  .ProseMirror .selectedCell:after { z-index: 2; position: absolute; content: ""; inset: 0; background: color-mix(in oklch, var(--primary) 20%, transparent); pointer-events: none; }
  .ProseMirror .column-resize-handle { position: absolute; right: -2px; top: 0; bottom: -2px; width: 4px; background-color: var(--ring); pointer-events: none; z-index: 20; }
  .ProseMirror.resize-cursor { cursor: col-resize; }
  .tableWrapper { padding-left: 10px; overflow-x: auto; max-width: 100%; }
`;

type TDocumentProseProps = ComponentProps<"div"> & { editable?: boolean };

export function DocumentProse({ children, className, editable: _editable, ...props }: TDocumentProseProps) {
  return (
    <div
      {...props}
      className={cn(
        "h-full max-w-none flex-1 overflow-auto text-foreground",
        "[&_p]:mb-3 [&_p]:typo-body-md [&_li]:mb-1 [&_li]:typo-body-md [&_strong]:font-semibold [&_em]:italic",
        "[&_h1]:mt-6 [&_h1]:mb-3 [&_h1]:typo-doc-h1 [&_h2]:mt-6 [&_h2]:mb-2 [&_h2]:typo-doc-h2 [&_h3]:mt-5 [&_h3]:mb-2 [&_h3]:typo-doc-h3 [&_h4]:mt-5 [&_h4]:mb-2 [&_h4]:typo-doc-h3",
        "[&_th]:typo-overline [&_th]:text-muted-foreground [&_td]:typo-body-sm",
        className
      )}
    >
      <style>{EDITOR_BEHAVIOR}</style>
      {children}
    </div>
  );
}
